var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('picture',[_c('source',{attrs:{"type":"image/webp","srcset":"/img/logo.webp"}}),_vm._v(" "),_c('img',{attrs:{"src":"/img/logo.png","alt":"Логотип ВОИР","width":"270","height":"70","fetchpriority":"high"}})])
}]

export { render, staticRenderFns }